var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"full"}},[_c('base-button',{staticClass:"btn-dark",on:{"click":function($event){return _vm.backToOrder()}}},[_vm._v("BACK")]),_c('base-button',{staticClass:"btn-dark",on:{"click":function($event){return _vm.print()}}},[_vm._v("PRINT")]),_c('div',{attrs:{"id":"report"},domProps:{"innerHTML":_vm._s(_vm.html)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }